import { parseContent, type Content } from '@ml/config';
import heroes from '../data/heroes.json' with { type: 'json' };
import monsters from '../data/monsters.json' with { type: 'json' };
import dungeons from '../data/dungeons.json' with { type: 'json' };
import buffPool from '../data/buffs.json' with { type: 'json' };

export const PACKAGE_NAME = '@ml/content';

/** Dữ liệu thô gộp từ data/*.json (chưa kiểm). Thiết kế: docs/gdd/content-mvp.md. */
export const rawContent: unknown = { heroes, monsters, dungeons, buffPool };

/** Content M1 đã qua parseContent() — throw ngay lúc import nếu data sai schema. */
export const content: Content = parseContent(rawContent);

export const DEFAULT_HERO_ID = 'aria';
export const DEFAULT_DUNGEON_ID = 'sunkenCrypt';

export type { Content };
